import UserLogin from './user-login.model';
import RememberPassword from './auth-remember-password.model';
import RecoveryPassword from './auth-recovery-password.model';

export default class AuthState {
    public userLogin: UserLogin = new UserLogin("", "");
    public rememberPassword: RememberPassword = new RememberPassword("");
    public recoveryPassword: RecoveryPassword = new RecoveryPassword("", "", "");
    public isLoading: boolean = false;
    public isSubmitted: boolean = false;
    public isErrorLogin: boolean = false;
    public isErrorRequest: boolean = false;
}